import {Injectable, Injector} from "@angular/core";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "./custom-object-type-search.model";

@Injectable()
export class InventoryCustomObjectTypeSearchModel extends CustomObjectTypeSearchModel {
    constructor(injector: Injector) {
        super(injector);
        this.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.INVENTORY;
    }

    override getResource(): string {
        return "custom-inventory-group-type";
    }
}
